/*
 * Bundles creados en la app Happymami (Bundles) para cualquier ficha de producto.
 * Pide a /apps/hm-menus/bundles los packs de esta ficha y mercado, deja elegir la variante de
 * cada pieza y los añade al carrito con el mismo _bundle_id. El precio del pack lo fija y cobra la
 * función de checkout: aquí nunca se calcula ni se aplica ningún descuento.
 * Pinta las mismas tarjetas que el bloque del biberón (happymami-bundle.css): .hm-pack, .hm-extra,
 * .hm-swatch y .hm-bundle__cta.
 */
(function () {
  'use strict';

  var COLOR_OPTION = /colou?r|tono|colore|couleur|farbe|kolor|^cor$/i;

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  // Las variantes que llegan de la app salen de la Admin API: incluyen las que se quitaron del catálogo del
  // mercado. La tienda (/products/<handle>.js) solo da las que se venden aquí, así que se queda con esas.
  function reconcileStorefront(packs) {
    var live = {};
    (packs || []).forEach(function (pack) {
      (pack.slots || []).forEach(function (slot) {
        (slot.items || []).forEach(function (item) {
          if (item && item.handle) live[item.handle] = null;
        });
      });
    });
    var handles = Object.keys(live);
    if (!handles.length) return Promise.resolve(packs);
    return Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .then(function (product) {
            if (product && product.variants && product.variants.length) live[handle] = product.variants;
          })
          .catch(function () {});
      })
    ).then(function () {
      (packs || []).forEach(function (pack) {
        (pack.slots || []).forEach(function (slot) {
          slot.items = (slot.items || [])
            .map(function (item) {
              var variants = item && live[item.handle];
              if (!variants) return item;
              var byId = {};
              variants.forEach(function (variant) {
                byId[String(variant.id)] = variant;
              });
              item.variants = (item.variants || [])
                .filter(function (variant) {
                  return byId[String(variant.id)];
                })
                .map(function (variant) {
                  variant.available = variant.available !== false && byId[String(variant.id)].available !== false;
                  return variant;
                });
              return item;
            })
            .filter(function (item) {
              return item && item.variants && item.variants.length;
            });
        });
      });
      return packs;
    });
  }

  function init(root) {
    var url =
      root.getAttribute('data-url') +
      '?product=' + encodeURIComponent(root.getAttribute('data-product') || '') +
      '&market=' + encodeURIComponent(root.getAttribute('data-market') || '') +
      '&locale=' + encodeURIComponent(root.getAttribute('data-locale') || '') +
      '&mode=generic&detail=1';
    var addUrl = root.getAttribute('data-add') || '/cart/add.js';
    var cartUrl = root.getAttribute('data-cart') || '/cart';
    var addLabel = root.getAttribute('data-add-label') || '';
    var chooseLabel = root.getAttribute('data-choose-label') || addLabel;
    var packsTitle = root.getAttribute('data-title') || '';
    var locale = (root.getAttribute('data-locale') || 'es').toLowerCase();
    var state = { packs: [], pack: '', picks: {} };

    function current() {
      for (var i = 0; i < state.packs.length; i += 1) {
        if (state.packs[i].id === state.pack) return state.packs[i];
      }
      return null;
    }

    function pickFor(pack, index) {
      var key = pack.id + ':' + index;
      var slot = pack.slots[index];
      var pick = state.picks[key];
      if (!pick) {
        pick = state.picks[key] = { item: 0, variant: '' };
      }
      var item = slot.items[Math.min(pick.item, slot.items.length - 1)];
      if (!item) return { item: null, variant: null };
      var variant = null;
      for (var i = 0; i < item.variants.length; i += 1) {
        if (item.variants[i].id === pick.variant && item.variants[i].available) variant = item.variants[i];
      }
      if (!variant) {
        for (var j = 0; j < item.variants.length; j += 1) {
          if (item.variants[j].available) {
            variant = item.variants[j];
            break;
          }
        }
      }
      return { item: item, variant: variant };
    }

    function swatchColors(item) {
      var colors = {};
      (item.optionValues || []).forEach(function (option) {
        (option.values || []).forEach(function (value) {
          if (value.color) colors[value.name] = value.color;
        });
      });
      return colors;
    }

    // Variante con el valor `value` en la opción `index` y el resto como la elegida.
    function variantWith(item, chosen, index, value) {
      var wanted = (chosen ? chosen.options : []).slice();
      wanted[index] = value;
      var exact = null;
      var loose = null;
      item.variants.forEach(function (variant) {
        if (!variant.available || !variant.options || variant.options[index] !== value) return;
        if (!loose) loose = variant;
        var same = variant.options.every(function (option, i) {
          return option === wanted[i];
        });
        if (same && !exact) exact = variant;
      });
      return exact || loose;
    }

    function optionRow(item, chosen, index, onChange) {
      var name = item.options[index];
      var values = [];
      item.variants.forEach(function (variant) {
        var value = variant.options && variant.options[index];
        if (value != null && values.indexOf(value) === -1) values.push(value);
      });
      if (values.length < 2) return null;
      var colors = swatchColors(item);
      var isColor =
        COLOR_OPTION.test(name) &&
        values.every(function (value) {
          return colors[value];
        });
      var row = el('div', 'hm-option');
      row.appendChild(el('p', 'hm-option__label', name));
      var list = el('div', isColor ? 'hm-swatches' : 'hm-pills');
      list.setAttribute('role', 'list');
      values.forEach(function (value) {
        var target = variantWith(item, chosen, index, value);
        var selected = !!(chosen && chosen.options && chosen.options[index] === value);
        var button = el('button', (isColor ? 'hm-swatch' : 'hm-pill') + (selected ? ' is-selected' : ''), isColor ? null : value);
        button.type = 'button';
        button.title = value;
        button.setAttribute('aria-label', value);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        if (isColor) {
          button.style.setProperty('--hm-swatch', colors[value]);
          button.style.setProperty('background-color', colors[value], 'important');
        }
        if (!target) button.disabled = true;
        button.addEventListener('click', function () {
          if (target) onChange(target.id);
        });
        list.appendChild(button);
      });
      row.appendChild(list);
      return row;
    }

    function previewSrc(variant, item) {
      return (variant && variant.image) || (item && item.image) || '';
    }

    function preview(src) {
      var box = el('span', 'hm-preview');
      box.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 2; i += 1) {
        var img = el('img', 'hm-preview__img' + (i === 0 ? ' is-on' : ''));
        img.alt = '';
        img.width = 68;
        img.height = 68;
        img.loading = 'lazy';
        img.decoding = 'async';
        if (i === 0 && src) img.src = src;
        box.appendChild(img);
      }
      return box;
    }

    // Fundido a la foto nueva en la otra <img>, como el bloque del biberón.
    function fadeTo(box, src) {
      var on = box.querySelector('.hm-preview__img.is-on');
      if (!src || (on && on.getAttribute('src') === src)) return;
      var next = box.querySelector('.hm-preview__img:not(.is-on)');
      if (!next) return;
      next.onload = function () {
        next.onload = null;
        next.classList.add('is-on');
        if (on) on.classList.remove('is-on');
      };
      next.src = src;
    }

    // Vuelve a pintar solo esta pieza y conserva su foto para que cambie con fundido.
    function refreshPiece(pack, slot, index, node) {
      var fresh = piece(pack, slot, index);
      var oldBox = node.querySelector('.hm-preview');
      var newBox = fresh.querySelector('.hm-preview');
      if (oldBox && newBox) {
        newBox.replaceWith(oldBox);
        fadeTo(oldBox, previewSrc(pickFor(pack, index).variant, pickFor(pack, index).item));
      }
      node.replaceWith(fresh);
      updateCta();
    }

    function packReady(pack) {
      return pack.slots.every(function (slot, index) {
        return !!pickFor(pack, index).variant;
      });
    }

    function updateCta() {
      var pack = current();
      if (!state.cta || !pack) return;
      var ready = packReady(pack);
      state.cta.disabled = !ready;
      state.cta.firstChild.textContent = ready ? addLabel : chooseLabel;
    }

    function piece(pack, slot, index) {
      var key = pack.id + ':' + index;
      var chosen = pickFor(pack, index);
      var wrap = el('div', 'hm-extra hm-extra--preview');
      if (!chosen.item) {
        wrap.appendChild(el('p', 'hm-extra__missing', '—'));
        return wrap;
      }
      wrap.appendChild(preview(previewSrc(chosen.variant, chosen.item)));
      wrap.appendChild(el('p', 'hm-extra__title', (slot.qty > 1 ? slot.qty + '× ' : '') + chosen.item.title));
      if (slot.items.length > 1) {
        var choice = el('div', 'hm-option');
        var pills = el('div', 'hm-pills');
        pills.setAttribute('role', 'list');
        slot.items.forEach(function (item, i) {
          var on = i === state.picks[key].item;
          var button = el('button', 'hm-pill' + (on ? ' is-selected' : ''), item.title);
          button.type = 'button';
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
          button.addEventListener('click', function () {
            state.picks[key] = { item: i, variant: '' };
            refreshPiece(pack, slot, index, wrap);
          });
          pills.appendChild(button);
        });
        choice.appendChild(pills);
        wrap.appendChild(choice);
      }
      for (var o = 0; o < chosen.item.options.length; o += 1) {
        var row = optionRow(chosen.item, chosen.variant, o, function (id) {
          state.picks[key].variant = id;
          refreshPiece(pack, slot, index, wrap);
        });
        if (row) wrap.appendChild(row);
      }
      return wrap;
    }

    function fillSlot(pack, slotBox) {
      var options = el('div', 'hm-options');
      var extras = el('div', 'hm-extras');
      pack.slots.forEach(function (slot, index) {
        extras.appendChild(piece(pack, slot, index));
      });
      options.appendChild(extras);
      slotBox.textContent = '';
      slotBox.appendChild(options);
    }

    // Estilo de la tarjeta que se edita en la app: borde, badge, texto inferior y tamaños (vacío = el del tema).
    function styleCard(node, pack) {
      [
        ['--hm-pack-border', pack.borderColor],
        ['--hm-badge-bg', pack.badgeColor],
        ['--hm-banner-bg', pack.bannerColor],
        ['--hm-badge-size', pack.badgeSize ? pack.badgeSize + 'px' : ''],
        ['--hm-banner-size', pack.bannerSize ? pack.bannerSize + 'px' : ''],
        ['--hm-sub-size', pack.subtitleSize ? pack.subtitleSize + 'px' : ''],
      ].forEach(function (rule) {
        if (rule[1]) node.style.setProperty(rule[0], rule[1]);
      });
    }

    function render() {
      root.textContent = '';
      if (packsTitle) root.appendChild(el('h3', 'hm-packs__title', packsTitle));
      var list = el('div', 'hm-packs');
      var ready = true;
      state.packs.forEach(function (pack) {
        var selected = pack.id === state.pack;
        var card = el('article', 'hm-pack' + (selected ? ' is-selected' : ''));
        card.style.setProperty('--hm-pack-accent', pack.color || '#f49898');
        styleCard(card, pack);
        if (pack.badge) card.appendChild(el('span', 'hm-badge', pack.badge));
        var head = el('button', 'hm-pack__header');
        head.type = 'button';
        head.setAttribute('aria-pressed', selected ? 'true' : 'false');
        var radio = el('span', 'hm-radio');
        radio.setAttribute('aria-hidden', 'true');
        head.appendChild(radio);
        var name = el('span', 'hm-pack__name', pack.title);
        if (pack.subtitle) name.appendChild(el('span', 'hm-pack__sub', pack.subtitle));
        head.appendChild(name);
        var price = el('span', 'hm-pack__price');
        if (pack.compare) {
          price.appendChild(el('s', '', pack.compare));
          price.appendChild(document.createTextNode(' '));
        }
        price.appendChild(el('strong', '', pack.price));
        head.appendChild(price);
        var slotBox = el('div', 'hm-pack__slot');
        head.addEventListener('click', function () {
          if (state.pack === pack.id) return;
          list.querySelectorAll('.hm-pack.is-selected').forEach(function (other) {
            other.classList.remove('is-selected');
            other.querySelector('.hm-pack__header').setAttribute('aria-pressed', 'false');
            other.querySelector('.hm-pack__slot').textContent = '';
          });
          state.pack = pack.id;
          card.classList.add('is-selected');
          head.setAttribute('aria-pressed', 'true');
          fillSlot(pack, slotBox);
          updateCta();
        });
        card.appendChild(head);
        if (selected) {
          fillSlot(pack, slotBox);
          ready = packReady(pack);
        }
        card.appendChild(slotBox);
        if (pack.banner) card.appendChild(el('p', 'hm-pack__banner', pack.banner));
        list.appendChild(card);
      });
      root.appendChild(list);

      var dock = el('div', 'hm-atc-dock');
      var button = el('button', 'hm-bundle__cta button button--full-width');
      button.type = 'button';
      button.appendChild(el('span', '', ready ? addLabel : chooseLabel));
      button.disabled = !ready;
      state.cta = button;
      var error = el('p', 'hm-bg__error');
      error.setAttribute('role', 'alert');
      error.hidden = true;
      button.addEventListener('click', function () {
        var pack = current();
        if (pack) add(pack, button, error);
      });
      dock.appendChild(button);
      root.appendChild(dock);
      root.appendChild(error);
      root.hidden = false;
    }

    function add(pack, button, error) {
      var bundle = uuid();
      var items = pack.slots.map(function (slot, index) {
        var chosen = pickFor(pack, index);
        return {
          id: Number(chosen.variant.id),
          quantity: slot.qty,
          properties: {
            _bundle_id: bundle,
            _bundle_title: pack.title,
            _hm_pack: pack.id,
            _tipo: slot.role,
            _hm_locale: locale,
          },
        };
      });
      button.disabled = true;
      button.classList.add('loading');
      error.hidden = true;
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'cart');
            return data;
          });
        })
        .then(function () {
          window.location.href = cartUrl;
        })
        .catch(function (failure) {
          error.textContent = failure && failure.message && failure.message !== 'cart' ? failure.message : '';
          error.hidden = !error.textContent;
          button.disabled = false;
          button.classList.remove('loading');
        });
    }

    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data || !data.packs || !data.packs.length) return;
        return reconcileStorefront(data.packs).then(function () {
          state.packs = data.packs.filter(function (pack) {
            return pack.slots.every(function (slot) {
              return slot.items && slot.items.length;
            });
          });
          if (!state.packs.length) return;
          state.pack = data.defaultPack || state.packs[0].id;
          if (!current()) state.pack = state.packs[0].id;
          render();
        });
      })
      .catch(function () {});
  }

  document.querySelectorAll('[data-hm-bundle-generic]').forEach(init);
})();
